export default {
  translation: {
    // header
    Discover: "Descubrir",
    WhyQriend: "¿Por qué QRiend?",
    LeaveMark: "Deja tu Huella",
    InstallNow: "Instalar Ahora",
    Login: "Iniciar Sesión",
    Register: "Registrarse",
    LogOut: "Cerrar Sesión",

    // footer
    HomePage: "Página de Inicio",
    QriendDescFooter: "¡Descubre nuevas amistades en entornos sociales, conoce de forma segura y moderna!",
    Pages: "Páginas",
    PrivacyAndSecurity: "Privacidad y Seguridad",
    HomePage: "Inicio",
    QriendTeam: "Nuestro Equipo",
    PrivacyPolicy: "Política de Privacidad",
    TermsOfUse: "Términos de Uso",
    DataSecurity: "Seguridad de Datos",
    CookiePolicy: "Política de Cookies",
    AccountSecurity: "Seguridad de Cuenta",
    LegalConsentAndDisclosureText: "Consentimiento Legal y Texto de Divulgación",
    ChildSafetyPolicy: "Política de Seguridad Infantil",
    PrivacySettingsGuide: "Guía de Configuración de Privacidad",
    SuitableForAllDevices: "Compatible con todos los dispositivos",
    DownloadNowFooter: "¡Descarga ahora, expande tu red social!",

    // delete request
    DeleteRequestTitle: "Solicitud de eliminación de cuenta",
    DeleteAccountQuestion: "¿Quieres eliminar tu cuenta?",
    Username: "Nombre de usuario",
    Password: "Contraseña",
    DeleteReason: "¿Por qué quieres eliminar tu cuenta?",
    UsernamePlaceholder: "Ingresa tu nombre de usuario",
    PasswordPlaceholder: "Ingresa tu contraseña",
    ReasonPlaceholder: "Explica por qué quieres eliminar tu cuenta...",
    SubmitDeleteRequest: "Enviar solicitud de eliminación",
    Warning: "Advertencia",
    WarningMessage: "La eliminación de la cuenta no se puede deshacer. Todos tus datos serán eliminados permanentemente.",
    RequestSubmittedSuccessfully: "Solicitud enviada exitosamente",
    RequestSubmittedMessage: "Tu solicitud de eliminación de cuenta ha sido recibida. Te responderemos lo antes posible.",
    SendNewRequest: "Enviar nueva solicitud",
    UsernameRequired: "El nombre de usuario es requerido",
    PasswordRequired: "La contraseña es requerida",
    ReasonRequired: "La razón de eliminación de cuenta es requerida",

    // register page
    createAccount: "Crear cuenta",
    createAccountDesc: "¡Regístrate ahora y comienza a conocer nuevas personas!",
    firstname: "Nombre",
    lastname: "Apellido",
    username: "Nombre de usuario",
    email: "Correo electrónico",
    password: "Contraseña",
    gender: "Género",
    male: "Masculino",
    female: "Femenino",
    noGender: "Prefiero no decir",
    registerMain: "Registrarse",
    registerDesc: "¿Ya tienes una cuenta?",
    registerLogin: "Iniciar sesión",
    kvkkConsent: "Acepto los acuerdos KVKK y de privacidad",
    kvkkConsentRequired: "Debes aceptar los acuerdos KVKK y de privacidad",
    privacyPolicy: "Política de privacidad",
    termsOfUse: "Términos de uso",

    // Landing Qriend Nedir?
    WhatIsQriend: "¿Qué es QRiend?",
    WhatIsQriendDesc: "Te permite conocer personas en el mismo lugar con tecnología QR. Ofrece una plataforma moderna y segura para conocer nuevas personas en espacios sociales como bares, cafés y restaurantes.",
    RealProfile: "Perfil Real",
    RealProfileDesc: "Solo interactúas con usuarios reales verificados.",
    InstantMeetingOpportunity: "Oportunidad de Encuentro Instantáneo",
    InstantMeetingOpportunityDesc: "Puedes conocer a alguien que ves en el lugar mediante mensajería instantánea.",
    VenueChats: "Chats de Lugar",
    VenueChatsDesc: "QRiend ofrece socialización digital en tu espacio.",

    // Landing Nasıl Tanışılır?
    HowtoMeet: "¿Cómo Conocer Gente?",
    HowtoMeetDesc: "¡Con nuestra aplicación, conocer personas en tiempo real en tu ubicación actual es ahora increíblemente fácil! Aquí tienes una guía paso a paso sobre cómo usarla;",
    EntryandConnectiontotheSpace: "Entrar y Conectarse al Lugar",
    EntryandConnectiontotheSpaceDesc: "Escanear el código QR con tu teléfono",
    EntryandConnectiontotheSpaceDesc2: "Iniciar sesión en la aplicación para unirse a la red del lugar",
    InSituExploration: "Exploración en el Lugar",
    InSituExplorationDesc: "Ver otros usuarios actualmente en el lugar",
    InSituExplorationDesc2: "Navegar por perfiles que te interesen",
    CommunicationInitiation: "Iniciación de la Comunicación",
    CommunicationInitiationDesc: "Enviar mensajes a personas que llamen tu atención",
    CommunicationInitiationDesc2: "Conectarse fácilmente con alguien con quien hiciste contacto visual",
    CommunicationInitiationDesc3: "Unirse al área de chat grupal de tu ubicación actual",
    SafeSocialization: "Socialización Segura",
    SafeSocializationDesc: "Conocerse mutuamente a través de mensajería mutua",
    SafeSocializationDesc2: "Puedes controlar o terminar la conversación en cualquier momento",
    SafeSocializationDesc3: "Continuar conociendo nuevas personas de manera divertida y segura",

    // Uygulamayı İndir Bölümü
    DownloadApp: "¡DESCARGA LA APP Y",
    DownloadApp2: "COMIENZA A EXPLORAR!",
    DownloadAppDesc: "¡Disponible en App Store y Google Play!",
    DownloadAppDesc2: "Descarga gratis,",
    DownloadAppDesc3: "descubre funciones premium.",

    // Discover
    DiscoverTitle: "Plataforma Innovadora y Social que Facilita Citas Reales",
    DiscoverDesc: "¿Estás cansado de mensajes interminables? ¿No te gustaría saber que estás en el mismo lugar que las personas que quieres conocer en la vida real? ¡Es exactamente por eso que nuestra aplicación es diferente!",
    DiscoverEp2: "¿Estás listo para verificar tu presencia en nuestros lugares asociados con tecnología QR y conocer personas reales en el mismo lugar?",
    DiscoverEp2Dot: "Seguimiento de Amistades",
    DiscoverEp2DotDesc: "Sigue perfiles que te gusten y descubre sus lugares favoritos. Aprovecha la oportunidad de conocer nuevos lugares y nuevas personas.",
    DiscoverEp3Dot: "Me Gusta de Perfiles y Lugares",
    DiscoverEp3DotDesc: "Conoce nuevas personas y descubre tus lugares favoritos a través de los perfiles y lugares que te gustan.",
    DiscoverEp4Dot: "Conoce en Ubicación",
    DiscoverEp4DotDesc: "A diferencia de las aplicaciones de citas ordinarias, ¡con nosotros todo es real! Puedes ver que estás en el mismo lugar que alguien que te gusta y conocerlo inmediatamente.",
    SwiperText: "Interfaz Conveniente",
    SafetyMeet: "Encuentros Más Seguros y Divertidos",
    RealTimeInteraction: "Interacción en Tiempo Real",
    RealTimeInteractionDesc: "En lugar de perderte en el mundo virtual, conoce personas que realmente están en el mismo lugar ahora mismo",
    RealTimeInteractionDesc2: "¿Quién está en tu café favorito? Ve instantáneamente y no pierdas la oportunidad de conocer",
    RealTimeInteractionDesc3: "Gracias a nuestra tecnología QR, verifica fácilmente el lugar donde estás",
    SecureAndVerifiedEnvironment: "Entorno Seguro y Verificado",
    SecureAndVerifiedEnvironmentDesc: "Socializa en nuestros lugares asociados",
    SecureAndVerifiedEnvironmentDesc2: "Con verificación de ubicación real, el riesgo de perfil falso es mínimo",
    SecureAndVerifiedEnvironmentDesc3: "Descubre y comparte tus lugares favoritos",
    BenefitsForBusinesses: "Beneficios para Empresas",
    BenefitsForBusinessesDesc: "Aumenta tu tráfico de clientes",
    BenefitsForBusinessesDesc2: "Crea un entorno con alta interacción social",

    // leave-mark
    LeaveMark: "Deja tu Huella",
    LeaveMarkTitle: "Deja tu Huella: Expande tu Experiencia Social y Construye Conexiones en Eventos",
    LeaveMarkDesc: "La función 'Deja tu Huella' de QRiend te permite expandir tu experiencia social en conciertos, festivales, conferencias y muchos otros eventos. Ahora puedes conocer nuevas personas no solo en lugares, sino en cada evento al que asistas.",
    How2Use: "¿Cómo Funciona?",
    How2UseDot1: "Únete al Evento",
    How2UseDot1Desc: "Ve a un concierto, festival, conferencia o cualquier evento",
    How2UseDot1Desc2: "Escanear el código QR especial de QRiend en el lugar del evento",
    How2UseDot1Desc3: "Conectarse instantáneamente al chat del evento",
    How2UseDot2: "Descubre Participantes del Evento",
    How2UseDot2Desc: "Ver otros usuarios de QRiend asistiendo al mismo evento",
    How2UseDot2Desc2: "Rastrea en tiempo real cuántas personas están activas en el chat del evento",
    How2UseDot2Desc3: "Encuentra personas que comparten tus intereses",
    How2UseDot3: "Interacciones Especiales",
    How2UseDot3Desc: "Puedes enviar emojis especiales a participantes que llamen tu atención",
    How2UseDot3Desc2: "Los emojis enviados aparecen en todo el chat como 'Usuario A envió un emoji corazón a Usuario B'",
    How2UseDot3Desc3: "El envío de emojis es una función premium y hace que conocer personas en eventos sea más divertido",
    WhereCanIUseIt: "¿Dónde Puedo Usarlo?",
    WhereCanIUseItDesc: "La forma más fácil de conocer nuevas personas en diferentes entornos, desde cafés hasta conciertos, festivales hasta restaurantes.",
    WhereCanIUseItDot1: "Deja tu Huella en Conciertos",
    WhereCanIUseItDot1Desc: "Escribe algo que dejará tu huella en el concierto al que asististe.",
    WhereCanIUseItDot2: "Deja tu Huella en Cafés",
    WhereCanIUseItDot2Desc: "Oportunidad de socializar en amplios círculos de amigos en cafés o pubs",
    WhereCanIUseItDot3: "Uso en Bares y Discotecas",
    WhereCanIUseItDot3Desc: "Socialización en la vida nocturna, noches temáticas y oportunidades de encuentro seguras",
    DownloadApp: "Descarga la Aplicación Móvil para Dejar tu Huella",

    // downloadPage
    DownloadNowNew: "Descarga Ahora y Comienza",
    DownloadNowNew2: "a Conocer Nuevas Personas",
    DownloadNowNew3: "¡Hoy!",
    DownloadNowDesc: "¡En cada lugar al que vayas, conoce nuevas personas con solo un código QR!",
    SupportPlatforms: "Plataformas y Dispositivos Soportados",
    SupportPlatformsDesc: "Acceso desde Cualquier Lugar",
    SupportPlatformsDesc2: "Dispositivos Móviles",
    SupportPlatformsDescDot: "Aplicación iOS (optimizada para iPhone e iPad)",
    SupportPlatformsDescDot2: "Aplicación Android (todos los teléfonos y tabletas Android)",

    // login ve register
    welcome: "Bienvenido",
    welcomeDesc: "¡Te extrañamos! Por favor inicia sesión para ponerte al día con lo que te has perdido.",
    email: "Correo Electrónico",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    login: "Iniciar Sesión",
    registerMain: "Registrarse",
    loginDesc: "¿Aún no tienes una cuenta?",
    loginReg: "Regístrate",
    createAccount: "Crear Cuenta",
    createAccountDesc: "Regístrate ahora y comienza a construir nuevas amistades.",
    firstname: "Nombre",
    lastname: "Apellido",
    username: "Nombre de Usuario",
    gender: "Género",
    password: "Contraseña (Al menos 6 caracteres)",
    register: "Registrarse",
    registerDesc: "¿Ya tienes una cuenta?",
    registerLogin: "Iniciar Sesión",
    rememberMe: "Recordarme",
    male: "Masculino",
    female: "Femenino",
    noGender: "Prefiero no especificar género",

    // Şifre Sıfırlama Onay - forgotPasswordConfirm.js

    passwordReset: "Restablecer Contraseña",
    passwordResetDesc: "Por favor, ingrese el código de 6 dígitos enviado a su correo electrónico y cree una nueva contraseña.",
    verificationCode: "Código de Verificación",
    codeValidityTime: "Tiempo de Validez del Código",
    newPassword: "Nueva Contraseña",
    newPasswordPlaceholder: "Ingrese la nueva contraseña",
    confirmPassword: "Confirmar Contraseña",
    confirmPasswordPlaceholder: "Confirme su contraseña",
    resettingPassword: "Restableciendo Contraseña...",
    resetPasswordButton: "Restablecer Contraseña",
    enterVerificationCode: "Ingrese el código de 6 dígitos de verificación.",
    passwordMinLength: "La contraseña debe contener al menos 6 caracteres.",
    passwordMismatch: "Las contraseñas no coinciden!",
    passwordResetSuccess: "¡Su contraseña ha sido restablecida con éxito!",
    passwordResetError: "No se pudo restablecer la contraseña, por favor intente nuevamente.",
  },
};